
const menuList =  [
  {
    id: 'shop',
    sections: [
      {
        title: 'All Posters',
        items: [
          { link: '/collections/new-arrivals', name: 'New Arrivals', title: 'New Posters' },
          { link: '/collections/best-selling', name: 'Best Selling', title: 'Popular Posters' },
          { link: '/collections/devotional', name: 'Devotional', title: 'Devotional Posters' },
          { link: '/collections/motivational', name: 'Motivational', title: 'Motivational Posters' }
        ]
      },
      {
        title: 'Cars & Bikes',
        items: [
          { link: '/collections/bikes', name: 'Bikes', title: 'Bike Posters' },
          { link: '/collections/concept-cars', name: 'Concept Cars', title: 'Concept Car Posters' },
          { link: '/collections/solid-cars', name: 'Solid Cars', title: 'Realistic Car Posters' },
          { link: '/collections/vector-cars', name: 'Vector Cars', title: 'Vector Car Posters' }
        ]
      },
      {
        title: 'Sports',
        items: [
          { link: '/collections/football', name: 'Football', title: 'Football Posters' },
          { link: '/collections/cricket', name: 'Cricket', title: 'Cricket Posters' },
          { link: '/collections/ufc', name: 'UFC', title: 'UFC Posters' },
          { link: '/collections/f1', name: 'F1', title: 'Formula 1 Posters' }
        ]
      },
      {
        title: 'Pop Culture',
        items: [
          { link: '/collections/marvel', name: 'Marvel', title: 'Marvel Posters' },
          { link: '/collections/dc', name: 'DC', title: 'DC Posters' },
          { link: '/collections/movies', name: 'Movies', title: 'Movie Posters' },
          { link: '/collections/tv-series', name: 'TV Series', title: 'TV Series Posters' },
          { link: '/collections/music', name: 'Music', title: 'Music Posters' },
          { link: '/collections/games', name: 'Games', title: 'Gaming Posters' }
        ]
      },
      {
        title: 'Make Your Own Poster',
        items: [
          { link: '/custom-poster', name: 'Create Now', title: 'Design Your Own Poster' }
        ]
      }
    ],
    images: []
  },
  {
    id: 'collections',
    sections: [
      {
        title: 'Explore ALL',
        items: [
          { link: '/collections/new-arrivals', name: 'New Arrivals', title: 'New Poster Splits' },
          { link: '/collections/best-selling', name: 'Best Selling', title: 'Top Selling Splits' },
          { link: '/collections/car-splits', name: 'Car Split Posters', title: 'Car Poster Splits' },
        ]
      },
      {
        title: 'Sports Split Posters',
        items: [
          { link: '/collections/sports-cricket', name: 'Cricket', title: 'Cricket Splits' },
          { link: '/collections/sports-football', name: 'Football', title: 'Football Splits' },
          { link: '/collections/sports-f1', name: 'F1', title: 'F1 Splits' },
          { link: '/collections/sports-wrestling', name: 'Wrestling', title: 'Wrestling Posters' },
          { link: '/collections/sports-top-picks', name: 'Sport Top-Picks', title: 'Top Sports Posters' }
        ]
      },
      {
        title: 'Entertainment Split Posters',
        items: [
          { link: '/collections/marvel', name: 'Marvel', title: 'Marvel Poster Splits' },
          { link: '/collections/dc', name: 'DC', title: 'DC Poster Splits' },
          { link: '/collections/movies', name: 'Movies', title: 'Movie Poster Splits' },
          { link: '/collections/tv-series', name: 'TV Series', title: 'TV Series Splits' },
          { link: '/collections/music', name: 'Music', title: 'Music Poster Splits' },
          { link: '/collections/gaming', name: 'Game Split Posters', title: 'Gaming Poster Splits' }
        ]
      },
      {
        title: 'Split by Pieces',
        items: [
          { link: '/collections/3-piece', name: '3-Piece Split Posters', title: '3-Part Posters' },
          { link: '/collections/5-panel', name: '5-Panel Split Posters', title: '5 Panel Poster Set' },
        ]
      }
    ],
    images: []
  }
];

export default menuList;